// this is an autogenerated file from App/Account/Content/Tasks/query-get-task-stage-done.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks($board_id: uuid!) {
  tasks_stages(
    where: { board_id: { _eq: $board_id }, done: { _eq: true } }
    limit: 1
  ) {
    id
  }
}

`